// Grab the alpha channel instead of `g`
// which threejs does by default for an alpha map
#ifdef USE_ALPHAMAP
  diffuseColor.a *= texture2D(alphaMap, vAlphaMapUv).a;
#endif
